<template>
    <div name="address" class="wrapper">

        <div class="page">  
            <loading 
                v-show="isLoading"
            />
            <address-modal 
                v-if="isAddressInputModal"
                @onClose="closeAddressInputModal"
                @apply="addressApply"
                :preAddress="this.diabetes_profiles[this.activeProfileId].profile.address"
                :preDetailAddress="this.diabetes_profiles[this.activeProfileId].profile.detail_address"
                :preAddressNickname="this.diabetes_profiles[this.activeProfileId].profile.address_nickname"
                :preZipCode="this.diabetes_profiles[this.activeProfileId].profile.zip_code"
                :preAddressDescription="this.diabetes_profiles[this.activeProfileId].profile.address_description"
                :isUpdate="isRegistered()"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
                <span class="header-text">배송지 관리</span>
            </div>
            <div class="contents-body">
                <text-label 
                    :text="'환자 선택'"
                    :isDefault="false"
                />
                <div class="name-button-list">
                    <div v-for="(info, index) in diabetes_profiles" style="margin-right: 16px;">
                        <div class="name-button-active" v-if="activeProfileId === index">
                            {{ info.profile.name }}
                        </div>
                        <div class="name-button-inactive" v-else @click="selectProfile(index)">
                            {{ info.profile.name }}
                        </div>
                    </div>
                </div> 
                <text-label 
                    :text="'등록된 배송지'"
                    :isDefault="false"
                />
                <span class="info-text" v-if="!isRegistered()">배송지를 미리 등록해 두시면 결제부터 배송까지 더욱 빠르게 이용하실 수 있어요</span>
                <div class="plus-button" v-if="!isRegistered()" style="margin-top: 16px;" @click="inputAddress">
                    <img style="width: 22px;" src="../assets/plus_btn.png" />
                    <span style="margin-left: 16px;">배송지 등록</span>
                </div>
                <address-card 
                    v-else
                    @updateAddress="inputAddress"
                    :address="this.diabetes_profiles[this.activeProfileId].profile.address"
                    :detailAddress="this.diabetes_profiles[this.activeProfileId].profile.detail_address"
                    :zipCode="this.diabetes_profiles[this.activeProfileId].profile.zip_code"
                    :addressNickname="this.diabetes_profiles[this.activeProfileId].profile.address_nickname"
                    :addressDescription="this.diabetes_profiles[this.activeProfileId].profile.address_description"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import Constant from '@/constant';
import cookies from '@/utilities/cookie.js';
import TextLabel from '@/components/atoms/TextLabel';
import AddressModal from '@/components/modals/AddressModal';
import AddressCard from '@/components/molecules/AddressCard';
import Loading from '@/components/molecules/Loading';

export default {
    name: 'deliveryMangement',
    computed: mapState(['diabetes_profiles', 'delivery']),
    components: {
        TextLabel,
        AddressModal,
        AddressCard,
        Loading
    },
    data: function()
    {
        return {
            activeProfileId: 0,
            isAddressInputModal: false,
            isLoading: false
        }
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
        }
        else
        {
            
            // 유효성 체크    
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                })
        }
    },
    methods: {
        isRegistered: function()
        {
            if(this.diabetes_profiles[this.activeProfileId].profile.address === null)
            {
                return false;
            }
            else {
                return true;
            }
        },
        selectProfile: function(index)
        {
            this.activeProfileId = index
        },
        back: function()
        {
            this.$router.push({path: '/home'})
        },
        inputAddress: function()
        {
            this.isAddressInputModal = true;
        },
        closeAddressInputModal: function()
        {
            this.isAddressInputModal = false;
        },
        addressApply: function(address, detailAddress, addressNickname, zipCode, addressDescription)
        {
            this.isAddressInputModal = false;
            this.isLoading = true;

            this.$store.commit(Constant.INITIALIZE_DELIVERY)
            this.delivery.address = address
            this.delivery.detail_address = detailAddress;
            this.delivery.zip_code = zipCode;
            this.delivery.address_nickname = addressNickname;
            this.delivery.address_description = addressDescription;


            this.$store.dispatch(Constant.UPDATE_DELIVERY, {profile_id: this.diabetes_profiles[this.activeProfileId].profile.id, token: this.token})
                .then(() => {
                    // reload
                     this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                        }) 
                        .catch(() => {
                            this.token = cookies.deleteLocalStorage("access_token");
                            this.isLoading = false;
                            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                        })
                })
                .catch((err) => {
                    this.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: var(--Gray-20, #FFF);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
    }
    .name-button-list {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        overflow-x: scroll;
    }
    .name-button-active {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .name-button-inactive {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .contents-body {
        padding: 16px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        background: var(--Gray-00, #FFF);
    }
    .header-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 16px;
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .plus-button {
        border-radius: 10px;
        border: 1px dashed var(--Gray-50, #A3AAB6);
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        height: 62px;
        cursor: pointer;
    }
    
</style>


// WEBPACK FOOTER //
// src/page/Address.vue